/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPayoutRequest
 */
export interface UserPayoutRequest {
    /**
     * 
     * @type {string}
     * @memberof UserPayoutRequest
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPayoutRequest
     */
    iban?: string;
}

export function UserPayoutRequestFromJSON(json: any): UserPayoutRequest {
    return UserPayoutRequestFromJSONTyped(json, false);
}

export function UserPayoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPayoutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'iban': !exists(json, 'iban') ? undefined : json['iban'],
    };
}

export function UserPayoutRequestToJSON(value?: UserPayoutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'iban': value.iban,
    };
}


